import { SET_TOKEN, CLEAR_TOKEN } from ":mutations";
import { REQUEST_EXCHANGE_TOKEN, REQUEST_TOKEN, RENEW_TOKEN } from ":actions";

import {
  requestExchangeToken,
  requestToken
} from "%services/security/SecurityService";

import jwtDecode from "jwt-decode";
import dayjs from "dayjs";
import http from ":http";

const state = {
  token: null
};

const mutations = {
  [SET_TOKEN](state, { token }) {
    state.token = token;
  },

  [CLEAR_TOKEN](state) {
    state.token = null;
  }
};

const actions = {
  [REQUEST_EXCHANGE_TOKEN](_, { mailAddress }) {
    return requestExchangeToken(mailAddress);
  },

  [REQUEST_TOKEN]({ commit }, { exchangeToken }) {
    return requestToken(exchangeToken).then(response =>
      commit(SET_TOKEN, { token: response.data.token })
    );
  },

  [RENEW_TOKEN]({ commit }) {
    return http.get("/users/authentication").then(response => {
      commit(SET_TOKEN, { token: response.data.token });
      return response;
    });
  }
};

const getters = {
  isSignedIn: state => !!state.token,
  jwtPayload: state => state.token && jwtDecode(state.token),
  loggedUser: (_, getters) => getters.jwtPayload && getters.jwtPayload.mail,
  permissions: (_, getters) => getters.jwtPayload && getters.jwtPayload.auth,
  jwtExpirationDate: (_, getters) =>
    getters.jwtPayload && dayjs(getters.jwtPayload.exp * 1000)
};

export default {
  state,
  mutations,
  actions,
  getters
};
